import { render } from "./SuccessMessage.vue?vue&type=template&id=2ea05398&scoped=true"
import script from "./SuccessMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessMessage.vue?vue&type=script&setup=true&lang=js"

import "./SuccessMessage.vue?vue&type=style&index=0&id=2ea05398&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea05398"],['__file',"src/modules/billing/components/SuccessMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ea05398"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ea05398', __exports__)) {
    console.log('reload')
    api.reload('2ea05398', __exports__)
  }
  
  module.hot.accept("./SuccessMessage.vue?vue&type=template&id=2ea05398&scoped=true", () => {
    console.log('re-render')
    api.rerender('2ea05398', render)
  })

}


export default __exports__